<div>
  <a [routerLink]="[Resources.PropertyContracts]" linkRewrite>
    <i class="ri-arrow-left-line"></i>
    <span>{{ 'CONTRACT.BACK' | translate }}</span>
  </a>

  @if (isLoading()) {
    <div class="mt-4">
      <p-skeleton height="400px" width="100%"></p-skeleton>
    </div>
  } @else {
    <div class="d-flex flex-wrap justify-content-between align-items-start gap-2">
      <div class="flex-grow-1 min-w-0">
        <p class="p-0 m-0 mt-3 fw-bolder fs-5 fs-md-4 text-break">
          {{ 'CONTRACT.CONTRACT_TITLE' | translate }} - {{ data()?.apartment?.apartmentName || data()?.building?.name }}
        </p>
        <p class="p-0 m-0 text-muted text-break">
          {{ 'CONTRACT.CONTRACT_NUMBER' | translate }}: {{ data()?.contractNumber }}
        </p>
      </div>
      <div class="d-flex flex-wrap justify-content-end align-items-center gap-2 mt-3 mt-md-0">
        <div class="text-md-end">
          <p-button (click)="downloadContract(id)" [loading]="downloadLoading">
            <i class="las la-file-export me-1"></i>
            <span class="me-1">{{ 'CONTRACT.PDF_EXPORT' | translate }}</span>
          </p-button>
        </div>
      </div>
    </div>
    <div class="row g-3">
      <div class="col-12 col-lg-9">
        <div class="mt-3" style="min-height: 415px;">
          <ul class="nav nav-tabs custom-tabs" role="tablist">
            <li *ngFor="let tab of TABS" class="nav-item">
              <a (click)="setActiveTab(tab.key)"
                 [ngClass]="{ 'active': activeTab === tab.key }"
                 class="nav-link cursor-pointer">
                <i [class]="tab.icon + ' me-2'"></i>
                {{ tab.label | translate }}
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <div [class.show]="activeTab === 'DETAILS'" class="tab-pane">
              <app-detail-of-contract-details [data]="data()" (edit)="onEdit()"></app-detail-of-contract-details>
            </div>

            <div [class.show]="activeTab === 'ZAHLUNGEN'" class="tab-pane">
              <app-payments-of-contract-details [data]="data()" (edit)="onEdit()"></app-payments-of-contract-details>
            </div>

            <div [class.show]="activeTab === 'SIDECOSTS'" class="tab-pane">
              <app-side-costs-of-contract-details [data]="data()"
                                                  (edit)="onEdit()"></app-side-costs-of-contract-details>
            </div>

            <div [class.show]="activeTab === 'DEPOSIT'" class="tab-pane">
              <app-deposit-of-contract-details [data]="data()" (edit)="onEdit()"></app-deposit-of-contract-details>
            </div>

            <div [class.show]="activeTab === 'DOKUMENTE'" class="tab-pane mt-1">
              <app-documents [renterId]="data()?.renterId" [hideActions]="true"/>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <div class="card">
          <div class="card-body">
            <p class="p-0 m-0 mb-1 d-flex justify-content-start align-items-center gap-2 fs-5">
              <span class="icon-circle"><i class="ri-community-line fs-5"></i></span>
              {{ 'CONTRACT.PROPERTY' | translate }}
            </p>
            <div class="ms-5">
              <p class="p-0 m-0 fw-bolder">
                {{ data()?.building?.addressArray?.streetName || '-' }}
                {{ data()?.building?.addressArray?.houseNumber || '-' }}
              </p>
              <p class="p-0 m-0 text-muted">
                {{ data()?.building?.addressArray?.postalCode || '-' }}
                {{ data()?.building?.addressArray?.cityName || '-' }}
              </p>
            </div>
          </div>
        </div>

        <div class="card my-3">
          <div class="card-body">
            <p class="p-0 m-0 mb-1 d-flex justify-content-start align-items-center gap-2 fs-5">
              <span class="icon-circle"><i class="ri-user-3-line fs-5"></i></span>
              {{ 'CONTRACT.RENTER' | translate }}
            </p>
            <div class="ms-5">
              <p class="p-0 m-0 fw-bolder">
                {{ (data()?.renter | renterName) || '-' }}
              </p>
              <p class="p-0 m-0 text-muted">
                {{ data()?.renter?.email || '-' }}
              </p>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <p class="p-0 m-0 d-flex justify-content-start align-items-center gap-2 fs-5">
              {{ 'CONTRACT.PAYMENT_RECONCILIATION' | translate }}
            </p>
            <p class="m-0 mb-1 p-0 text-muted fs-6">
              {{ 'CONTRACT.PAYMENT_RECONCILIATION_DESC' | translate }}
            </p>
            <div class="d-flex justify-content-between align-items-center mb-1">
        <span class="text-muted">
          {{ 'CONTRACT.EXPECTED_AMOUNT' | translate }}
        </span>
              <span class="fw-bolder">
          {{ data()?.totalRent | moneyFormat }}
        </span>
            </div>
            <div (click)="payment()" class="w-100 bg-secondary text-light rounded-3 py-1 text-center cursor-pointer">
              {{ 'CONTRACT.RECONCILE_PAYMENTS' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

  }
</div>
